import { ControlSheetAnnotation, ControlSheetNote, ControlSheetTrip } from '../../types/types'
import clsx from 'clsx'
import { DutyAnnotationTooltip } from '../../ui/DutyAnnotationTooltip'
import { DutyTooltip } from '../../ui/DutyTooltip'
import styles from '../ControlSheetCells.module.scss'
import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query'
import { ControlSheetDTO } from '@/types/controlsheet'
import ChatIcon from '../../assets/chat.svg'
import EditIcon from '../../assets/edit.svg'
import Clock from '../../../../pages/ControlSheet/assets/clock.svg'
import { DualTooltipMealRelief } from '../../ui/DualTooltipMealRelief'
import { AnnotationsPermission } from '@/pages/ControlSheet/ui/ControlSheetPage'

interface Props {
    route: string
    refetchControlSheet: (
        options?: RefetchOptions | undefined
    ) => Promise<QueryObserverResult<ControlSheetDTO[], Error>>
    trip?: ControlSheetTrip
    run: string
    annotationsPermission: AnnotationsPermission
    addTempNote: (note: ControlSheetNote) => void
    deleteTempNote: (noteId: string) => void
    addTempAnnotation: (annotation: ControlSheetAnnotation) => void
}

export const DutyCell = ({
    route,
    refetchControlSheet,
    trip,
    run,
    annotationsPermission,
    addTempNote,
    deleteTempNote,
    addTempAnnotation,
}: Props) => {
    if (!trip) {
        return <div className={clsx(styles.cell, styles.duty)}></div>
    }

    if (trip.isTakeoverRow) {
        return <div className={clsx(styles.cell, styles.duty)}>{trip.duty}</div>
    }

    const generalAnnotations = trip.annotations.filter((it) => it.annotationType === 'General')
    const annotation = generalAnnotations.length > 0 ? generalAnnotations[0] : null

    const annotationTooltipComponent = (
        <DutyAnnotationTooltip
            duty={trip.duty}
            trip={trip.trip}
            run={run}
            route={route}
            annotationId={annotation?.id}
            existingNotes={annotation?.notes ?? []}
            addTempNote={addTempNote}
            deleteTempNote={deleteTempNote}
            addTempAnnotation={addTempAnnotation}
            onUpdate={() => {
                refetchControlSheet()
            }}
        />
    )

    const tooltipComponent = <DutyTooltip route={route} trip={trip} annotationsPermission={annotationsPermission} />

    return (
        <DualTooltipMealRelief
            tooltip={tooltipComponent}
            clickTooltip={annotationTooltipComponent}
            placement="bottom"
            trigger={annotationsPermission === 'edit' ? 'hover+click' : 'hover'}
        >
            <div
                className={clsx(styles.cell, styles.duty, {
                    [styles.cellEdit]: annotationsPermission === 'edit',
                    [styles[`duty${trip.code}`]]: trip.code,
                })}
            >
                <div>{trip.duty}</div> {trip.code ?? trip.code} {trip.isNearDrivingHours && <Clock />}
                {annotation && annotation.notes.length > 0 && (
                    <div className={styles.commentIcon}>
                        <ChatIcon />
                    </div>
                )}
                <div className={styles.editIcon}>
                    <EditIcon />
                </div>
            </div>
        </DualTooltipMealRelief>
    )
}
